// const $t = (input) => {
//   return window.Vue?.$t(input) || input
// }

export default {
  canonicalUri: []
}
